// Simple ApexCharts error prevention
import Vue from 'vue'

// Data validation function
const validateApexChartsData = (series) => {
  if (!series) return []
  if (!Array.isArray(series)) return []
  
  return series.filter(s => s !== null && s !== undefined).map(s => {
    if (typeof s !== 'object') {
      return { name: 'series', data: [] }
    }
    
    const validated = { ...s }
    
    // Ensure data is always an array
    if (!Array.isArray(validated.data)) {
      validated.data = []
    }
    
    // Clean data array
    validated.data = validated.data.filter(point => point !== null && point !== undefined).map(point => {
      if (typeof point === 'number') return point
      if (typeof point === 'object' && point !== null) {
        return {
          x: point.x !== undefined ? point.x : 0,
          y: point.y !== undefined ? point.y : 0,
          ...point
        }
      }
      return 0
    })
    
    return validated
  })
}

// Global mixin with safe methods
Vue.mixin({
  methods: {
    validateChartData(data) {
      return validateApexChartsData(data)
    },
    
    safeSeriesComputed(rawSeries, fallback = []) {
      const validated = validateApexChartsData(rawSeries)
      return validated.length > 0 ? validated : fallback
    }
  }
})

// Override console.error only for ApexCharts errors to reduce noise
const originalError = console.error
console.error = function(...args) {
  const message = String(args[0] || '')
  if (message.includes('Cannot read properties of undefined') && 
      (message.includes('reading \'length\'') || message.includes('ApexCharts'))) {
    // Suppress ApexCharts undefined errors
    return
  }
  originalError.apply(console, args)
}

export default {
  validateApexChartsData
}
